import { prop, map, mergeAll, pick, values } from 'ramda';

export const combineServiceMethods = (methodList = [''], serviceObj) => (args, options) => Promise.all(values(pick(methodList, serviceObj)).map(e => e(args, options))).then(responses => mergeAll(map(prop('data'))(responses)));
